import { render } from "./CardListadoEtiquetas.vue?vue&type=template&id=021d75fa&scoped=true"
import script from "./CardListadoEtiquetas.vue?vue&type=script&lang=js"
export * from "./CardListadoEtiquetas.vue?vue&type=script&lang=js"

import "./CardListadoEtiquetas.vue?vue&type=style&index=0&id=021d75fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021d75fa"]])

export default __exports__